
contactAgency = new ContactAgency();
window.ContactAgency = ContactAgency;
window.gaOpenPopup = '';
window.sendContact = sendContact;

var classNameActiveButton = "activeButton";

function ContactAgency() {
	this.$ca = this;
}

ContactAgency.prototype.setContactEvent = function(){
	var $ca = this.$ca;
	$('#contactAgency, #contactAgencyAggregator, .send_contact_form').addClass(classNameActiveButton);
	
	$(document)
		.off('click','#contactAgency.' + classNameActiveButton + ', #contactAgencyAggregator.' + classNameActiveButton + ', .send_contact_form.' + classNameActiveButton)
		.on('click','#contactAgency.' + classNameActiveButton + ', #contactAgencyAggregator.' + classNameActiveButton + ', .send_contact_form.' + classNameActiveButton, function(e){
			var id = "#"+$(this).parents('form').attr("id");
			$ca.contact(id);
		})
}

ContactAgency.prototype.setResourcesCheckboxes = function(){
	
	$('.resource-checkbox').unbind();
	$('.resource-checkbox').on('click', function(e){		
		e.stopPropagation();
		var $form = $(this).parents('form');
		var $checkbox = $(this).prev();		
		var checkboxId = $checkbox.attr('id');
		
		$form.find('#'+checkboxId).trigger('click');		
		var activated = $checkbox.is(":checked");
		
		if(activated){
			var urId = jsUtils.replaceAll($checkbox.attr('id'), "contacto-","");
			var mail = $form.find('#contacto-'+urId).attr('data-mail');
			$form.find('#resourceId').val(urId);
			$form.find('#emailToSend').val(mail);	
			
			$form.find('.resource-checkbox').each(function(index, elem){
				$ch = $(elem).prev()
				if($ch.is(':checked')){
					$form.find('#'+$ch.attr('id')).trigger('click');					
				}
			})
			$form.find('#'+checkboxId).trigger('click');
		}
		
	});
	
	$('.trigger-checkbox')
		.off('click')
		.on('click', function(){
			$(this).prev().trigger('click');
		});



}


function saveGoogleConversionFor(agencyType) {
    if (typeof (goog_report_conversion) == "function") {
        goog_report_conversion(agencyType);
    }
}

function loadPhoneValidationLibThen(callback, errorCallback) {
	$.ajax({
			type: "GET",
			url: "https://script.resemmedia.com/script/script/intlTelInput.utils.min.js",
			dataType: "script",
			cache: true,
			// jQuery 1.11 loads a script from another domain with a <script> tag and never reports a failed
			// load: without a timeout neither callback would run and the contact would get stuck
			timeout: 5000,
			success: callback,
			error: errorCallback
		}
	);
}
window.loadPhoneValidationLibThen = loadPhoneValidationLibThen;

// Los formularios pintados al cargar la pagina, y las plantillas de los modales, llevan el telefono que
// habia en la cookie al pintarla: tras un envio que lo guarda se rellenan los vacios para no volver a
// pedirlo sin recargar. Los que ya tienen algo no se tocan para no pisar lo que este escribiendo el usuario.
function rememberUserPhone(phone) {
	if (!phone) {
		return;
	}
	document.querySelectorAll("input[type='tel']").forEach(function (input) {
		if (input.value !== '') {
			return;
		}
		var intlInstance = window.intlTelInputGlobals ? window.intlTelInputGlobals.getInstance(input) : null;
		if (intlInstance) {
			intlInstance.setNumber(phone);
		} else {
			input.value = phone;
		}
	});
	// Los modales se pintan con el html de la plantilla, que solo lleva el atributo value, no la propiedad
	document.querySelectorAll("template").forEach(function (template) {
		template.content.querySelectorAll("input[type='tel']").forEach(function (input) {
			if (!input.getAttribute('value')) {
				input.setAttribute('value', phone);
			}
		});
	});
}
window.rememberUserPhone = rememberUserPhone;

ContactAgency.prototype.contact = function(id){
	function disableButtons(){
		$('#contactAgency, #contactAgencyAggregator, .send_contact_form').removeClass(classNameActiveButton)
	}
	
	function enableButtons(){
		$('#contactAgency, #contactAgencyAggregator, .send_contact_form').addClass(classNameActiveButton);
	}
	
	function contactAgency(parameters, callback) {
		$.ajax({
			type: "POST",
			url: "/agency/contact",
			accepts: "application/json",
			dataType: "json",
			data: parameters,
			success: callback,
			complete: enableButtons
		});
	}

	function manageContactResponseFor(id, phone) {
		return function (response) {
			rememberUserPhone(phone);
			return manageContactResponse(response, id);
		}
	}

	function manageContactResponse(response, id) {
	    var agencyType = response.agencyType;
		var msg = response.message;

		// Vuelta Atras RTB
		var msgs = msg.split("####");
		if (msgs.length > 1) {
			contactId = msgs[0];
			rtbKey = msgs[1];
			msg = msgs[2];
		}
		// Vuelta Atras RTB


		//We create the vars as global to be used in analytics methods
		adId = $(id).find('[name="adId"]').val();
		agencyId = $(id).find('[name="agencyId"]').val();
		partner = $(id).find('[name="partner"]').val();
		locationShown = $(id).find('[name="locationShown"]').val();
		adTitle = $(id).find('[name="adTitle"]').val();
		var where = $(id).find('[name="where"]').val();

		$(id).find('.input-group').remove();
		$(id).find('.column').remove();
		$(id).find('.inputs-area').remove();
		$(id).find('.form-df').remove();
		$(id).append(msg);

		if (where === "listing") {
			analytics.submitListingContactAgencyCommerce();
		} else if (where === "home") {
			analytics.submitHomeContactAgencyCommerce();
		} else if (where.startsWith('detail')) {
			analytics.submitDetailContactAgencyCommerce();
		} else if (where.startsWith('aggregator')) {
			analytics.submitAggregatorContactAgencyCommerce(where);
		} else {
			analytics.submitDetailContactAgencyCommerce();
			if (typeof where === undefined || where === '') {
				where = 'notInformed';
			}
		}
		analytics.submitSendContact(where);
        saveGoogleConversionFor(agencyType);
        // Vuelta Atras RTB
		if (analytics.contactRTB) {
			analytics.submitSendContactRTB(contactId, rtbKey, adId);
		}
		// Fin Vuelta Atras RTB
	}

	disableButtons();

	$(id+' .pop-up-contacto .toggle-area').css('max-height','5000px');	
	
	$(id).find('.has-error').each(function(index, elem){
		$(this).removeClass('has-error');
	})

	var ret = false;
	var result = false;

	$(id + " [required='required']").each(function(){
		result = toggleError($(this).attr("type"), $(this));
		if (result)
			ret = true;
	});

	// Validate email fields correct format
	$(id + " [data-type='email']").each(function (){
		result = toggleError($(this).attr("data-type"), $(this));
		if(result)
			ret = true;
	});

	if (ret) {
		enableButtons();
		return false;
	}

	var otherFields = "";
	$(id).find(".otherField").each(function (){
		if ($(this).val() != "") {
			if (otherFields == "") {
				otherFields = "{";
			}
			else {
				otherFields += ",";
			}
			var auxText = $(this).attr("associatedTag");
			while (auxText != undefined && auxText.indexOf("'") > -1) {
				auxText = auxText.replace("'", "\"");
			}
			if ($(this).attr("type") == "checkbox") {
				otherFields += '"' + auxText + '":"' + $(this).prop("checked") + '"';
			}else {
				if ($(this).attr("type") == "tel"){
					otherFields += '"telTag":"' + auxText + '",';
				}
				otherFields += '"' + auxText + '":"' + $(this).val().replace("'", "\"") + '"';
			}
		}
	});
	if (otherFields != "")
		// add json other fields as parameter, escaping new lines
		otherFields = "&otherFields=" + otherFields.replace(/\n/g, "\\\\n") + "}";


	loadPhoneValidationLibThen(function () {
		var phoneInput = document.querySelector(id + "	 input[id^='contact-phone']");
		if (typeof phoneInput !== 'undefined' && phoneInput !== null) {
			var intlInstance = window.intlTelInputGlobals.getInstance(phoneInput);
			phoneInput = $(id).find("[name='telefono']");
			var queryInput = $(id + " input[id^='contact-phone']");
            var phoneNumber = intlInstance.getNumber();
            if (intlInstance.isValidNumber()) {
				phoneInput.val(phoneNumber);
				queryInput.removeClass("has-error");
			} else if (phoneNumber.length > 0) {
				queryInput.addClass("has-error");
				enableButtons();
				return false;
			}
		}

		var parameters = $(id).serialize() + otherFields;
		var pvParams = getPvParams();
		if (pvParams) {
			parameters += "&pvParams=" + pvParams;
		}

		contactAgency(parameters, manageContactResponseFor(id, $(id).find("[name='telefono']").val()));
	}, enableButtons)
}

var whatsAppButton = (function () {

    var BUTTON_SELECTOR = '.btn-whatsapp';
    var POPUP_SELECTOR = '.pop-up-detail';
    var MENU_LAYER_SELECTOR = '.menu__layer';

    var initialButtonText;
    // Con el telefono ya guardado el modal se salta y cada clic enviaria un contacto: mientras uno esta en
    // curso los demas clics se ignoran.
    var inProgress = false;

    // Enlaza los botones de WhatsApp de la pagina. Publico para poder re-enlazar si se pinta
    // contenido nuevo por ajax.
    function init() {
        $(BUTTON_SELECTOR).on('click', function () {
            if (inProgress) {
                return;
            }
            inProgress = true;
            var $button = $(this);
            saveInitialButtonText($button);
            changeButtonText($button, processingText);
            requestChatLink($button);
        });
    }

    function saveInitialButtonText($button) {
        if ($button.find('span').length > 0) {
            initialButtonText = $button.find('span').first().text();
        } else {
            initialButtonText = $button.text();
        }
    }

    function changeButtonText($button, text) {
        if ($button.find('span').length > 0) {
            $button.find('span').first().text(text);
        } else {
            $button.text(text);
        }
    }

    function restoreButtonText($button) {
        changeButtonText($button, initialButtonText);
    }

    // phoneNumber es opcional: solo llega cuando el usuario acaba de escribirlo en el modal de
    // tracking, o cuando ya lo tenemos guardado y el modal se salta.
    function requestChatLink($button, phoneNumber) {
        $.post(generateCheckerUrl($button, phoneNumber)).done(function (data) {
            var json = JSON.parse(data);

            if (json.printApplyModal) {
                openApplyModal($button);
                restoreButtonText($button);
                return;
            }

            inProgress = false;

            if (json.canStartWhatsAppTracking) {
                openTrackingModal($button);
                return;
            }

            restoreButtonText($button);

            if (json.url) {
                rememberUserPhone(phoneNumber);
                openChat(json);
            } else {
                showErrorPopUp(json.errorMsg);
            }
        }).fail(function () {
            inProgress = false;
        });
    }

    function openChat(json) {
        analytics.submitEvent(json.agencyId, json.adId, json.promotionDetailId, json.eventType, json.eventSubtype);
        analytics.send();

        saveGoogleConversionFor(json.agencyType);
        openApiOrWeb(json.url);
    }

    function openApiOrWeb(url) {
        if (jQuery.browser.mobile) {
            document.location.href = url;
        } else {
            var a = document.createElement('a');
            a.target = "_blank";
            a.href = url;
            a.click();
        }
    }

    function generateCheckerUrl($button, phoneNumber) {
        var url = '/sendWhatsApp/?ad=' + $button.attr('data-adId');

        if (!(typeof $button.attr('data-ag') === 'undefined')) {
            url += "&ag=" + $button.attr('data-ag');
        }
        if (!(typeof $button.attr('data-pd') === 'undefined')) {
            url += "&pd=" + $button.attr('data-pd');
        }

        url += "&es=click_detail";

        var dataStatus = $button.attr('data-status');
        if (!(typeof dataStatus === 'undefined')) {
            url += "&st=" + dataStatus;
        }

        if (jQuery.browser.mobile) {
            url += "&de=mobile";
        } else {
            url += "&de=desktop";
        }

        var pvParams = getPvParams();
        if (pvParams) {
            url += "&pvParams=" + encodeURIComponent(pvParams);
        }
        if (phoneNumber) {
            url += "&up=" + encodeURIComponent(phoneNumber);
        }
        return url;
    }

    function openApplyModal($button) {
        var popup = $(POPUP_SELECTOR);
        var menuLayer = $(MENU_LAYER_SELECTOR);
        popup.html($("#whatsapp-modal").html());

        // Como en el modal de tracking: con el telefono ya guardado y valido el modal se salta. Si no carga
        // la libreria de validacion el telefono no se puede validar y el modal se abre.
        var formId = "#" + popup.find('form').attr("id");
        var skipOrOpenModal = function () {
            var phoneInput = popup.find('#contact-phone-whatsapp');
            if (phoneInput.length > 0 && !togglePhoneError(phoneInput.first(), true)) {
                postApply(popup, menuLayer, formId, function () {
                    inProgress = false;
                });
                return;
            }
            phoneInput.removeClass("has-error");
            inProgress = false;

            // Los handlers se enlazan al contenido recien pintado, no a document: delegar en document
            // acumulaba un handler por apertura del modal y el submit acababa enviando N peticiones.
            popup.find(".pop-up__arrow").on("click", function () {
                closeModal(popup, menuLayer);
            });
            popup.find("#submitWhatsappForm").on("click", function (e) {
                setPreventAndPropagation(e);
                sendApply(popup, menuLayer, this);
            });

            openModal(popup, menuLayer);
            sendApplyImpression($button);
        };
        loadPhoneValidationLibThen(skipOrOpenModal, skipOrOpenModal);
    }

    function sendApply(popup, menuLayer, obj) {
        var id = "#" + $(obj).parents('form').attr("id");

        // isValidNumber() cannot validate until intlTelInput.utils is loaded. If loading it fails
        // the phone is validated anyway: isValidNumber() returns null and does not block the submit.
        var validateAndSend = function () {
            var hasErrors = false;

            $(id).find('.has-error').removeClass('has-error');

            $(id + " [data-type='intl']").each(function () {
                if (togglePhoneError($(this), false)) {
                    hasErrors = true;
                }
            });

            if (hasErrors) {
                return;
            }

            postApply(popup, menuLayer, id);
        };

        loadPhoneValidationLibThen(validateAndSend, validateAndSend);
    }

    function postApply(popup, menuLayer, id, onComplete) {
        var phone = getValidPhoneNumber(id);
        // Only the hidden fields go as they are: the phone goes in international format.
        $.ajax({
            type: "POST",
            url: "/applyWhatsapp",
            data: $(id + " input[type='hidden']").serialize()
                + "&phone=" + encodeURIComponent(phone)
                + "&pvParams=" + getPvParams(),
            success: function (data) {
                var dataJSON = JSON.parse(data);
                if (dataJSON.status === 200) {
                    rememberUserPhone(phone);
                    openApiOrWeb(dataJSON.url);
                    closeModal(popup, menuLayer);
                }
            },
            error: function (data) {
                var dataJSON = JSON.parse(data.responseText);
                popup.html(dataJSON.message);
                openModal(popup, menuLayer);
            },
            complete: onComplete
        });
    }

    function openTrackingModal($button) {
        var popup = $(POPUP_SELECTOR);
        var menuLayer = $(MENU_LAYER_SELECTOR);
        popup.html($("#whatsapp-tracking-modal").html());

        var formId = "#" + popup.find('form').attr("id");
        loadPhoneValidationLibThen(function () {
            var phoneInput = popup.find('#contact-phone-whatsapp-tracking');
            if (phoneInput.length > 0 && !togglePhoneError(phoneInput.first(), true)) {
                phoneInput.removeClass("has-error");
                requestChatLink($button, getValidPhoneNumber(formId));
                return;
            }

            restoreButtonText($button);
            phoneInput.removeClass("has-error");

            popup.find(".pop-up__arrow").on("click", function () {
                closeModal(popup, menuLayer);
            });
            popup.find("#viewFormWhatsapp").on("submit", function (e) {
                setPreventAndPropagation(e);
                sendApplyTracking(popup, menuLayer, this, $button);
            });

            openModal(popup, menuLayer);
            sendApplyImpression($button);
        });
    }

    function sendApplyTracking(popup, menuLayer, form, $button) {
        // closest y no parents: form es el propio formulario, y parents excluye al elemento
        var id = "#" + $(form).closest('form').attr("id");

        // isValidNumber() no puede validar hasta que este cargado intlTelInput.utils.
        // Si la carga falla se valida igual: isValidNumber() devuelve null y no bloquea el envio.
        loadPhoneValidationLibThen(function () {
            var ret = false;

            // los errores del intento anterior se limpian antes de volver a validar
            $(id).find('.has-error').removeClass('has-error');

            $(id + " [data-type='intl']").each(function () {
                if (togglePhoneError($(this), false)) {
                    ret = true;
                }
            });

            if (ret) {
                return;
            }

            requestChatLink($button, getValidPhoneNumber(id));
            closeModal(popup, menuLayer);
        });
    }

    // La apply impression del paso 2 mide que el modal se ha mostrado, por eso se envia desde aqui
    // y no desde /sendWhatsApp: el servlet decide mostrarlo, pero no sabe si se ha pintado (con el
    // telefono ya guardado el modal de tracking se salta). Una impression por apertura de modal.
    function sendApplyImpression($button) {
        var adId = $button.attr('data-adId');
        var pvParams = getPvParams();
        // /smp responde 400 sin adId o sin pvParams
        if (!adId || !pvParams) {
            return;
        }

        $.post("/smp", {
            adId: adId,
            dcstai: "AD_CTA_WHATSAPP",
            dcstais: 2,
            pvParams: pvParams
        });
    }

    function openModal(popup, menuLayer) {
        menuLayer.addClass("is-active");
        popup.addClass("is-active");
    }

    function closeModal(popup, menuLayer) {
        popup.removeClass("is-active");
        menuLayer.removeClass("is-active");
        popup.empty();
    }

    function showErrorPopUp(errorMsg) {
        var cssStyle = {
            "max-height": "150px",
            "display": "flex",
            "flex-direction": "column",
            "justify-content": "center",
            "align-items": "center",
            "vertical-align": "middle",
            "z-index": "10",
            "border": "8px solid #87c535",
            "width": "550px",
            "top": "0",
            "bottom": "0",
            "left": "0",
            "right": "0",
            "margin": "auto",
            "overflow-y": "hidden",
        };

        var closeCssStyle = {
            "position": "absolute",
            "top": "0"
        };

        var popUpDetail = $(POPUP_SELECTOR);
        var txtDiv = $("<div></div>").text(errorMsg);
        var closeLink = $("<a></a>").addClass("ui-link-0").attr("href", "#").append("<div></div>");
        var close = $("<div></div>").addClass("pop-up__arrow").css(closeCssStyle).append(closeLink).on("click", function () {
            popUpDetail.empty();
            popUpDetail.removeAttr("style");
            popUpDetail.removeClass("is-active");
        });

        popUpDetail.append(close).append(txtDiv).css(cssStyle).addClass("is-active");
    }

    $(document).ready(init);

    return {
        init: init
    };
})();
window.whatsAppButton = whatsAppButton;

function showPopUpDetail(url, parameters, beforeLoad){
	$('.pop-up-detail').load(url, parameters, function(){		
		$('.pop-up-detail').addClass('is-active');
		$('.menu__layer').addClass('is-active');
		$(body).addClass("blocking");
		//$('body').addClass('fixed');

		$('.ui-link-0').on('click', function(e){
			e.preventDefault();
			$('.menu__layer').removeClass('is-active');
			$(body).addClass("blocking");
			//$('body').removeClass('fixed');
			$('.pop-up-detail').empty();
			$('.pop-up-detail').removeClass('is-active')

			$(document).trigger('pop-up-closed');
		})
		
		if(typeof beforeLoad==="function")
			beforeLoad();
	})
}

$(document).ready(function(){
	loadbtncontact();
	
});

function loadbtncontact(){
	$(document).on('click','.btn-contact', function(e){
        e.preventDefault();
		e.stopPropagation();
        sendContact.call(this);
    });
}

function sendContact() {
    var aggregator = false;

    if (typeof ($(this).attr("data-adId")) != "undefined") {
        aggregator = true;
    }

    var dataWhere = $(this).attr("data-where");
    var contactSubtypeName = $(this).attr("data-contactSubtype");
    if ($('article.ag-detail').length > 0 || $('article.ag-article').length > 0) {
        if (!contactSubtypeName) {
            if ($(this).attr("data-where") && $(this).attr("data-where") == 'listing') {
                contactSubtypeName = 'AGGREGATOR_DETAIL_AD_PAYMENT_LISTING';
                if ($(this).parents('li.ad.similar').length > 0) {
                    contactSubtypeName += '_SIMILAR';
                } else if ($(this).parents('li.ad.premier').length > 0) {
                    contactSubtypeName += '_PREMIUM';
                }
                dataWhere = 'aggregator-ad-listing';
            } else {
                contactSubtypeName = 'AGGREGATOR_DETAIL_AD';
                if ($(this).parents('article.ag-detail').length > 0) {
                    contactSubtypeName += "_THIN";
                } else if ($(this).parents('article.agF-article').length == 0) {
                    contactSubtypeName += "_PREMIUM";
                }
                dataWhere = 'aggregator-ad-detail';
            }
        }
    } else if (!contactSubtypeName) {
        if ($(this).attr("data-where") && $(this).attr("data-where") == 'listing') {
            contactSubtypeName = 'ADS_LISTING';
            if ($(this).parents('li.ad.similar').length > 0) {
                contactSubtypeName = 'ADS_SIMILAR';
            } else if ($(this).parents('li.ad.premier').length > 0) {
                contactSubtypeName = 'ADS_PREMIUM_LISTING';
            }
        } else {
            contactSubtypeName = '';
        }
    }

    $('.pop-up-contacto').empty();
    var dateFormat = $(this).attr("data-dateFormat");
    if (typeof dateFormat == 'undefined') {
        dateFormat = 'dd/mm/yyyy';
    }

    var language = $(this).attr("data-language");
    if (typeof language == 'undefined') {
        language = 'es';
    }


    $('.pop-up-contacto').load('/www/resem/new_design/common/pop-up-contacto.jsp', {
        adId: $(this).attr("data-adId"),
        where: dataWhere,
        contactSubtypeName: contactSubtypeName,
        promotionDetailId: $(this).attr("data-promotionDetailId"),
        dayOpenHouse: $(this).attr("data-dayOpenHouse"),
        contactMessage: $(this).attr("data-message"),
        contactType: $(this).attr("data-type"),
        pvParams: getPvParams(),
        gaPageType: gaPageType,
        listingPosition: getListingPosition($(this)),
        titlePage: gaPageTitle
    }, function (response) {
        $('.menu__layer').on('click', function () {
            $('.menu__layer').removeClass('is-active');
            $('.pop-up-contacto').removeClass('is-active');
            $(body).removeClass("blocking");
            $('.pop-up-contacto').trigger('contacto:close');

            $(document).trigger('pop-up-closed');
        });
        $('.pop-up-contacto .pop-up__arrow a').on('click', function () {
            $('.menu__layer').removeClass('is-active');
            $('.pop-up-contacto').removeClass('is-active');
            $(body).removeClass("blocking");
            $('.pop-up-contacto').trigger('contacto:close');
            $('body').removeClass('fixed');
            if (aggregator && typeof (agContact) != "undefined") {
                if (agContact == true) {
                    $(".aggregator-big-free").hide();
                    $(".aggregator-big").hide();
                    agContact = false;
                }
            }

            $(document).trigger('pop-up-closed');
        });
        $('.pop-up-contacto').on('contacto:close', function () {
            $('.pop-up-contacto .toggle-area').css('max-height', '0px');

        });
        if (typeof analytics != 'undefined' && $('.pop-up-contacto .toggle-area').css('max-height') != '5000px') {
            var whereAnalytics = '';
            if (dataWhere) {
                whereAnalytics = dataWhere;
            }
            popup.sendOpenContactPopupEvent(whereAnalytics, window.gaOpenPopup);
        }
        $('.pop-up-contacto .toggle-area').css('max-height', '5000px');

        contactAgency.setResourcesCheckboxes();
        contactAgency.setContactEvent();
        try {
            contactAgency.setDatepicker(dateFormat, language);
        } catch (e) {
            ;
        }
    })
    $('.pop-up-contacto').addClass('is-active');
    $('.menu__layer').addClass('is-active');
    $(body).addClass("blocking");
    if ($('.pop-up-contacto.is-active').css('position') != 'fixed') {
        $(document).scrollTop(0);
    }
}

function createFieldIncompletePopover(elem,message,place){
	
	try{
		$(elem).popover({
			container:'body',
			trigger:'manual',
			html:true,
			placement:place,
			title:function(){
				return "<p></p><script>$('.popover-title').hide();</script>"
			},
			content:message
		});
		
		$(elem).on("click",function(){
			$(this).popover('hide');
		});
	}catch(e){
		
	}
}

// Fallback cuando intl-tel-input no puede validar: solo comprobamos que sean digitos
// y una longitud plausible. E.164 admite 15 digitos como maximo.
function isBasicPhoneValid(value) {
	var text = String(value).trim();
	var digits = text.replace(/\D/g, '');
	return /^\+?[\d\s().-]+$/.test(text) && digits.length >= 6 && digits.length <= 15;
}

// Devuelve el telefono que ha introducido el usuario en el formulario indicado, normalizado
// a E.164 por intlTelInput. Si la libreria no puede normalizarlo se devuelve el valor tal
// cual lo escribio el usuario. Se espera llamarla despues de validar con toggleError('intl').
function getValidPhoneNumber(formId) {
	var elem = $(formId).find("[data-type='intl']").get(0);
	if (!elem) {
		return '';
	}
	return phoneNumberOf(elem);
}

function phoneNumberOf(elem) {
	var intlInstance = window.intlTelInputGlobals
		? window.intlTelInputGlobals.getInstance(elem)
		: null;
	// getNumber() devuelve '' si intlTelInput.utils no esta cargado
	var phoneNumber = intlInstance ? intlInstance.getNumber() : '';
	return phoneNumber ? phoneNumber : String($(elem).val()).trim();
}

// Valida el campo de telefono y devuelve el numero normalizado, o null si no es valido. Sin la libreria de
// validacion cargada hace la comprobacion basica y devuelve el numero tal cual se escribio.
function validPhoneOf($input) {
	$input.removeClass("has-error");
	if (togglePhoneError($input, false)) {
		return null;
	}
	return phoneNumberOf($input.get(0));
}
window.validPhoneOf = validPhoneOf;

function toggleError (type, elem){

	var value = $(elem).val();
	if(value == 'undefined' || value == ''){
		elem.addClass("has-error");
		return true;
	}
	
	if (type == 'email') {
		if (!jsUtils.validateMail($(elem).val())){
			elem.addClass("has-error");
			return true;
		}
	}
	else if (type == 'checkbox') {
		if(!$(elem).is(':checked')){
			elem.next().addClass("has-error");
			return true;
		}
	}
	
	return false;
}

function togglePhoneError (elem, mandatoryInternational){
    const value = $(elem).val();
    if(value === 'undefined' || value === ''){
		elem.addClass("has-error");
		return true;
	}

    // getInstance espera un nodo del DOM, no el objeto jQuery, y devuelve null si intlTelInput
    // no se inicializo sobre este input (ver JSUtils.loadDialCodeCountries, que solo cubre
    // input[id^='contact-phone'] e input[id^='phone-'])
    const intlInstance = window.intlTelInputGlobals
            ? window.intlTelInputGlobals.getInstance($(elem).get(0))
            : null;
    // null = la libreria no puede validar (intlTelInput.utils sin cargar): comprobacion basica
    let isValid = intlInstance ? intlInstance.isValidNumber() : null;
    if (!mandatoryInternational && isValid === null) {
        isValid = isBasicPhoneValid($(elem).val());
    }
    if (!isValid) {
        $(elem).addClass("has-error");
        return true;
    }

	return false;
}

$(document).ready(function () {
	$('.openHouse').find('.open').click(function () {
		var object = $(this);
		$('.pop-up-contacto').load('/www/resem/new_design/common/pop-up-black.jsp',{
			}, function(){
				var popUpElement = $('.pop-up-contacto');
				popUpElement.addClass('openHouse');
				popUpElement.find('.pop-up__title').html(object.html());
				popUpElement.find('.pop-up__subtitle').html(object.attr('title'));
				popUpElement.find('.pop-up-form').html(object.parent().html());
				popUpElement.find('.pop-up-form').find('.open.offer').remove();
				popUpElement.find('.pop-up-form').find('.open.direction').remove();
				popUpElement.find('.pop-up-form').prepend($(document.createElement('div')).attr('class', 'title').html(object.parent().parent().attr('title')));
				$('.menu__layer').on('click',function(e){
					closeLayer(e);
				});
				$('.pop-up-contacto .pop-up__arrow a').on('click',function(e){
					closeLayer(e);
				});
		});
		$('.menu__layer').addClass('is-active');
		$('.pop-up-contacto').addClass('is-active');
		$(body).addClass("blocking");
		if ($(window).width()>=768) {
			$('.pop-up-contacto').css('top', $(window).scrollTop());
			$('.pop-up-contacto').css('min-height', 'auto');
			$("body").css("overflow-y" , "hidden");			
		}
	});
});

function closeLayer(e) {
	e.preventDefault();
	e.stopPropagation();
	$('.menu__layer').removeClass('is-active');
	$('.pop-up-contacto').removeClass('is-active');
	$('.pop-up-contacto').removeClass('openHouse');
	$(body).removeClass("blocking");
	if ($(window).width()>=768) {
		$('.pop-up-contacto').css('top', 0);
		$('.pop-up-contacto').css('min-height', 'inherit');
		$("body").css("overflow-y" , "auto");
	}
}
function getListingPosition (obj){
    if (obj.parents('ul.listAds').length > 0) {
        return obj.parents('li').index() + 1;
    }
    if (obj.parents('ul.slick-slider').length > 0) {
        return obj.parents('.slick-slide').data('slick-index') + 1;
    }
    if (obj.parents('ul.listado-viviendas').length > 0) {
        return obj.parents('li.vivienda-item').index() + 1;
    }
    return 1;
}